import {action, computed, observable} from "mobx";
import CampaignStore from "./CampaignStore";
import uuidv4 from 'uuid/v4';
import TemplateStore from "./TemplateStore";
import {Template} from "./Template";
import CampaignInterface from "./CampaignInterface";
import Widget from "./Widget";

export default class Campaign implements CampaignInterface {

    store: CampaignStore;

    id: number | null = null;

    post_id: number;

    mailchimpWebId: string = '';

    key: string;

    status: string = 'draft';

    @observable template: Template | undefined;

    @observable templateStore: TemplateStore;

    @observable name: string = "";

    @observable mailServiceFields = {
        preview: '',
        title: '',
        from: '',
        subjectLine: '',
        replayTo: '',
    };

    @observable mailchimpListId: any = '';

    @observable mailchimpCampaignId: any;

    constructor(store: CampaignStore, templateStore: TemplateStore, key = uuidv4()) {
        this.store = store;
        this.post_id = this.store.getPostIdFromUrl();
        this.templateStore = templateStore;
        this.key = key;
        this.template = this.templateStore.createTemplate(this.templateStore.templates[0]);
    }

    @computed get asJson(): CampaignInterface {
        const json = JSON.parse(
            JSON.stringify({
                id: this.id,
                key: this.key,
                mailchimpWebId: this.mailchimpWebId,
                mailServiceFields: this.mailServiceFields,
                status: this.status,
                name: this.name,
                mailchimpListId: this.mailchimpListId,
                mailchimpCampaignId: this.mailchimpCampaignId,
                post_id: this.post_id,
            })
        );
        json.template = this.template && this.template.asJson;
        return json;
    }

    @action setHtml(html: string = '') {
        if (this.template) {
            this.template.html = html;
        }
    }

    setTemplate = (templateId: number | undefined) => {
        let template;

        if (typeof templateId !== "undefined") {
            template = this.templateStore.getTemplate(templateId);
        }
        if (template) {
            this.template = this.templateStore.createTemplate(template);
        } else {
            this.template = template;
        }

    };

    updateFromJson(json: any) {
        if (!json) {
            return;
        }
        this.mailchimpWebId = json.mailchimpWebId;
        this.mailchimpListId = json.mailchimpListId;
        this.mailchimpCampaignId = json.mailchimpCampaignId;
        this.id = Number(json.id);
        this.name = json.name;
        this.key = json.key;
        this.status = json.status;
        this.mailServiceFields = json.mailServiceFields;
        this.template = this.templateStore.createTemplate(json.template);
    }

    @action setWidgetSelected(widgetIndex: number | null = null) {
        if (this.template) {
            this.template.setWidgetSelected(widgetIndex);
        }
    }

    @action setMailchimpListId(id: number) {
        this.mailchimpListId = id;
    }

    @computed get selectedWidget(): Widget | null {
        return (this.template && this.template.selectedWidget) ? this.template.selectedWidget : null;
    }

    save = async () => {
        const response: any = await this.store.api.saveCampaign(this.asJson);
        this.updateFromJson(response.campaign);
        return response;
    }

    sendTest = async (emails: []) => {
        const response: any = await this.store.api.sendTest(this.asJson, emails);
        return response;
    }

    send = async () => {
        return await this.store.api.send(this.asJson);
    }


}
